import TimePickerField from "../../../common/TimePickerField";
import useClassLevel from "src/hooks/useClassLevel";
import useCoach from "src/hooks/useCoach";
import { classLevelOptions, coachOptions } from "./utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import BasicModal from "src/features/student-attendance/components/modal";
import { useState } from "react";
import TimeTableForm from "./time-table-form";
import { toast } from "react-toastify";
import { usePostRegularClassSchedules } from "src/services/react-query-apis/post-regular-class-schedules";
import TimeTableUpdateConfirm from "./time-table-update-confirm";
import TimeTableDeleteConfirm from "./time-table-delete-confirm";
import { useRegularClassQuery } from "src/services/react-query-apis/get-regular-class";

const TimeTableCell = ({ schedule, day, regularClassId }) => {
  const classLevel = useClassLevel();
  const coach = useCoach();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [updatePayload, setUpdatePayload] = useState(null);

  const handleClose = () => {
    setIsOpen(false);
    setUpdatePayload(null);
  };

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      setTimeout(() => {
        handleClose();
      }, 1000);
    },
  };

  const postRegularClassSchedulesMutation = usePostRegularClassSchedules({
    mutationConfig,
  });

  const handleSubmit = payload => {
    if (schedule.id) {
      setUpdatePayload({
        ...payload,
        id: schedule.id,
      });
      setIsOpen(true);
    } else {
      postRegularClassSchedulesMutation.mutate({ data: payload });
    }
  };

  const regularClassQuery = useRegularClassQuery({
    id: regularClassId,
    queryConfig: {
      enabled: !!regularClassId,
    },
  });

  const isRankClass = regularClassQuery.data?.data?.rank_flag === 1;

  return (
    <>
      <BasicModal
        title="スケジュール編集"
        isOpen={isOpen}
        onCancel={handleClose}
        width={1000}
      >
        {updatePayload ? (
          <TimeTableUpdateConfirm
            updatePayload={updatePayload}
            onClose={handleClose}
            onBack={() => setUpdatePayload(null)}
          />
        ) : (
          <TimeTableForm
            schedule={schedule}
            day={day}
            regularClassId={regularClassId}
            onSubmit={handleSubmit}
          />
        )}
      </BasicModal>
      <div
        style={{ cursor: "pointer" }}
        className="time-table-cell "
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <div className="pe-none">
          <TimePickerField name="start_time" value={schedule.start_time} />
          <div style={{ fontSize: "10px" }}>|</div>
          <TimePickerField name="end_time" value={schedule.end_time} />
        </div>
        {isRankClass && (
          <div className="pe-none d-flex gap-2 flex-column align-items-center">
            <div>定員</div>
            <input
              className="w-25 text-center"
              type="number"
              onChange={() => {}}
              value={schedule.max_student}
            />
          </div>
        )}

        <div className="table-select pe-none">
          コースレベル
          <select
            className="form-select"
            value={schedule.class_level_id}
            onChange={e => {
              console.log(e.target.value);
            }}
          >
            {classLevelOptions(classLevel.list).map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="mt-1 table-select pe-none">
          コーチ
          <select
            className="form-select"
            value={schedule.coach_id}
            onChange={e => {
              console.log(e.target.value);
            }}
          >
            {coachOptions(coach.list).map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div>
        <div className="mt-2 d-flex gap-1 justify-content-center time-table-cell-buttons">
          <button
            className="btn btn-sm btn-primary"
            title="このスケジュールを編集"
            onClick={() => setIsOpen(true)}
          >
            <FontAwesomeIcon icon="edit" />
          </button>
          {schedule.start_time && (
            <>
              <button
                className="btn btn-sm btn-danger"
                title="このスケジュールを削除"
                onClick={() => setIsDeleteOpen(true)}
              >
                <FontAwesomeIcon icon="trash" />
              </button>
              <BasicModal
                title="スケジュールの削除"
                isOpen={isDeleteOpen}
                onCancel={() => setIsDeleteOpen(false)}
                width={1000}
              >
                <TimeTableDeleteConfirm
                  schedule={schedule}
                  onClose={() => setIsDeleteOpen(false)}
                >
                  <div className="pe-none">
                    <TimeTableForm
                      schedule={schedule}
                      day={day}
                      regularClassId={regularClassId}
                      onSubmit={handleSubmit}
                    />
                  </div>
                </TimeTableDeleteConfirm>
              </BasicModal>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TimeTableCell;
